import React, {useState} from "react";
import DropdownMenu from "../../components/DropdownMenu";
import {useHistory} from "react-router-dom";
import {Acessos} from "./Acessos";
import {Header} from "../../components/structure/Header";
import {SEText} from "../../components/SEText";
import {Grid} from "@mui/material";
import {AtendimentosSala} from "./AtendimentosSala";
import {ReportsFilterProvider} from "../../../context/ReportsFilterContext";
import {AtendimentosSse} from "./AtendimentosSse";
import {AtendimentosSebrae} from "./AtendimentosSebrae";
import { AtendimentosAgenteSseCredito } from "./AtendimentosAgenteSseCredito";

const Reports = () => {
  const history = useHistory();

  const menuOptions = [
    {
      id: "acessos",
      label: "Acessos",
      component: <Acessos />,
    },
    {
      id: "agendamentos",
      label: "Agendamentos",
    },
    {
      id: "atendimentos-sse",
      label: "Atendimentos SSE",
      component: <AtendimentosSse />,
    },
    {
      id: "atendimentos-sala",
      label: "Atendimentos Sala",
      component: <AtendimentosSala />,
    },
    {
      id: "atendimentos-sebrae",
      label: "Atendimentos Sebrae",
      component: <AtendimentosSebrae />,
    },
    {
      id: "atendimentos-agente-sse-credito",
      label: "Agente SSE Crédito",
      component: <AtendimentosAgenteSseCredito />,
    },
    {
      id: "diagnosticos",
      label: "Diagnósticos Realizados",
    },
    {
      id: "registros-sas",
      label: "Registros (SAS)",
    },
    {
      id: "usuarios",
      label: "Usuários",
    },
    {
      id: "notificacoes",
      label: "Notificações",
    },
    {
      id: "perfil-do-usuario",
      label: "Perfil do usuário",
    },
  ];

  const [selectedOption, setSelectedOption] = useState(menuOptions[0]);

  const handleChangeMenu = (option: any) => {
    setSelectedOption(option);
    history.push(`/reports/${option.id}`);
  };

  return (
    <ReportsFilterProvider>
      <React.Fragment>
        <Header>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item style={{ flexGrow: 1 }}>
              <SEText type="title">Relatórios</SEText>
            </Grid>
            <Grid
                item
                style={{
                  flexGrow: 2,
                  paddingRight: 24,
                  paddingTop: 16,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
            >
              <DropdownMenu
                  options={menuOptions}
                  selectedOption={selectedOption?.id}
                  onSelect={handleChangeMenu}
              />
            </Grid>
          </Grid>
        </Header>

        <Grid item>

          <Grid container>
            <Grid item xs={12}>
              {selectedOption?.component}
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    </ReportsFilterProvider>
  );
};

export default Reports;
